import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Tags, { getTag } from '../../common/Tags';
import PixDiscountTag from '../../search/plans_table/PixDiscountTag';

import { formatURL, formatPrice, convertDate, getAllCookies, getMaxParcel } from '../../../utils';
import { openModalQuotationDateWarning } from '../../../actions/coverageActions';
import { openModalEmail } from '../../../actions/comparisonActions';

import './CurrentPurchase.css';

class CurrentPurchase extends Component {
  constructor(props) {
    super(props);
    this.purchasePlan = this.purchasePlan.bind(this);
  }

  componentDidMount() {
    const bar = document.querySelector('.top-detail-coverage');
    const list = document.querySelector('.detalhes-cobertura');
    if (list && bar && !this.props.mobile)
      window.addEventListener('scroll', () => {
        if (window.scrollY > 139) {
          bar.classList.add('fixedd');
          list.style.marginTop = '100px';
        } else {
          bar.classList.remove('fixedd');
          list.style.marginTop = '5px';
        }
      });
  }

  sendToRDStation = async () => {
    try {
      let lead_mail,
        lead_name = '';

      const cookies = getAllCookies();
      for (const [key, value] of Object.entries(cookies)) {
        if (key.trim() === 'LeadEmail') {
          lead_mail = decodeURIComponent(value);
        }
        if (key.trim() === 'LeadName') {
          lead_name = decodeURIComponent(value);
        }
      }

      const response = await fetch('https://www.rdstation.com.br/api/1.3/conversions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token_rdstation: '904297ddf27aa488461f1936e94791d6',
          identificador: 'ver_cobertura_comprar',
          email: lead_mail,
          nome: lead_name,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        console.log('Response Data:', data);
        console.log('Success!');
      } else {
        console.log('Error: ', response.statusText);
      }
    } catch (error) {
      console.error('Fetch Error:', error);
    }
  };

  purchasePlan = async () => {
    this.sendToRDStation();
    const location = {
      pathname: formatURL(
        this.props.match.params,
        `/pedido/${this.props.match.params.product_code}/${this.props.match.params.destination}/${this.props.match.params.begin_date}/${this.props.match.params.end_date}/`
      ),
    };
    this.props.history.push(location);
  };

  render() {
    if (!this.props.plans[0] || !this.props.destinations[0] || !this.props.providers[0] || !this.props.providers[0].slug) return <div />;

    let pixDiscountMultiplier = 0.95;
    if (this.props.paymentMethods && this.props.paymentMethods.length > 0) {
      const pixPayment = this.props.paymentMethods.find(method => method.slug === 'pix');
      if (pixPayment && pixPayment.discount > 0) {
        pixDiscountMultiplier = (100 - pixPayment.discount) / 100;
      }
    }

    const plan = this.props.plans[0] || {
      provider_code: '2',
      provider_name: '',
      name: '',
      adult: { price: 0 },
      extra: { special: '', travel_renewal: 'no' },
      elder: {},
    };

    const destinations = this.props.destinations;

    const providers = this.props.providers;

    let destination = destinations.filter((destination) => destination.slug === this.props.match.params.destination)[0]
      .name;

    const providerSlug = providers.filter((provider) => provider.code === plan.provider_code)[0].slug;

    let termsUrl = providers.filter((provider) => provider.slug === providerSlug)[0].terms_url;

    let provider_img_path = `/assets/images/seguradoras/${providerSlug}.png`;

    return (
      <React.Fragment>
        <div className="top-detail-coverage">
          <div className="component">
            <h2 className="top-detail-title">Resumo da cobertura</h2>
            <div className="content-resume-mobile">
              <div className="details-insured-mobile">
                <Tags tag={getTag(plan)} isMobile />
                <div className="details-group-mobile">
                  <div className="brand-mobile">
                    <img className="img-insured" src={provider_img_path} alt="Logo - Seguradora" />
                  </div>
                  <div className="info-plan">
                    <p className="p-principal">{this.props.productCoverage.name}</p>

                    <p className="p-span-normal">
                      <span>
                        Faixa etária: {this.props.productCoverage.min_age} a {this.props.productCoverage.max_age} anos{' '}
                      </span>

                      {plan.elder.min_age < plan.elder.max_age && (
                        <span style={{ marginLeft: '5px' }}>
                          <React.Fragment>
                           R${' '}
                            {this.props.plans.length > 0 &&
                              `${formatPrice(this.props.plans[0].elder.price)} maiores de ${
                                this.props.plans[0].adult.max_age
                              }`}
                          </React.Fragment>
                        </span>
                      )}
                    </p>
                  </div>
                </div>

                <div className="details-group-mobile-info">
                  <p className="p-title-normal">{destination}</p>
                  <span className="span-small">
                    <span>
                      {convertDate(this.props.match.params.begin_date)} -{' '}
                      {convertDate(this.props.match.params.end_date)}
                    </span>
                  </span>

                  <div className="send-mail more-details">
                    <a href={termsUrl} target="_blank" rel="noopener noreferrer">
                      Ver condições gerais
                    </a>
                  </div>
                </div>
              </div>

              <div className="details-insured-desktop">
                <div className="brand-mobile">
                  <img className="img-insured" src={provider_img_path} alt="Logo - Seguradora" />
                </div>

                <div className="group-details-info-desktop">
                  <div className="info-plan">
                    <p className="p-principal">{this.props.productCoverage.name}</p>

                    <p className="p-span-normal">
                      <span>
                        Faixa etária: {this.props.productCoverage.min_age} a {this.props.productCoverage.max_age} anos
                      </span>

                      {plan.elder.min_age < plan.elder.max_age && (
                        <span>
                          <React.Fragment>
                            R${' '}
                            {this.props.plans.length > 0 &&
                              `${formatPrice(this.props.plans[0].elder.price)} maiores de ${
                                this.props.plans[0].adult.max_age
                              }`}
                          </React.Fragment>
                        </span>
                      )}
                    </p>

                    <div className="send-mail more-details">
                      <a href={termsUrl} target="_blank" rel="noopener noreferrer">
                        Ver condições gerais
                      </a>
                    </div>

                    <p className="p-title-normal">{destination}</p>
                    <span className="span-small">
                      <span>
                        {convertDate(this.props.match.params.begin_date)} -{' '}
                        {convertDate(this.props.match.params.end_date)}
                      </span>
                    </span>

                    <button onClick={this.props.openModalEmail} className="btn-send-details-email">
                      <img src="/assets/images/icons/plane.svg" />
                      <span>Enviar cobertura por e-mail</span>
                    </button>
                  </div>

                  <div className="info-price">
                    <Tags tag={getTag(plan)} />
                    {plan.price_with_coupon_discount ?  (
                      <span className="old-price">R$ {formatPrice(plan.adult.price)}</span>
                    ) : null}
                    <div className="value">
                      <strong>R$ {formatPrice(plan.price_with_coupon_discount || plan.adult.price)}</strong>{' '}
                      <span>
                        {' '}
                        {getMaxParcel(plan.price_with_coupon_discount || plan.adult.price)}x sem juros no cartão
                      </span>
                    </div>
                    <div className="value-pix">
                      R${' '}
                      {formatPrice(
                        plan.price_with_coupon_discount ?
                          (plan.price_with_coupon_discount * pixDiscountMultiplier).toFixed(2) :
                          (plan.adult.price * pixDiscountMultiplier).toFixed(2)
                      )}
                      <PixDiscountTag />
                    </div>
                    <button type="button" className={`btn-purchase`} onClick={this.purchasePlan}>
                      Comprar
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <button onClick={this.props.openModalEmail} className="btn-mobile-send-details-email">
              <img src="/assets/images/icons/plane.svg" />
              <span>Enviar cobertura por e-mail</span>
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      plans: state.search.plans,
      userDetails: state.coverage.userDetails,
      mobile: state.mobile.mobileActive,
      productCoverage: state.coverage.productCoverage,
      providers: state.global.providers,
      destinations: state.global.destinations,
      paymentMethods: state.purchase.paymentMethods,
    }),
    { openModalQuotationDateWarning, openModalEmail }
  )(CurrentPurchase)
);



// WEBPACK FOOTER //
// ./src/components/coverage/current_purchase/CurrentPurchase.jsx